var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { p as pushCartDataLayer } from "./g-utils.fc76ffa2.chunk.js";
class GModal extends HTMLElement {
  constructor() {
    super();
    this.contentWrapper = this.querySelector(".js-modal-content-wrapper");
    this.content = this.querySelector(".js-modal-content");
    this.expanded = false;
    this.overflowHiddenDsk = this.dataset.overflowHiddenDsk === "true" || false;
    this.overflowHiddenMob = this.dataset.overflowHiddenMob === "true" || false;
  }
  connectedCallback() {
    window.addEventListener("click", (e) => {
      const modalContent = e.target.closest(".js-modal-content");
      if (!(modalContent && modalContent.isEqualNode(this.content))) {
        this.close();
      }
    });
  }
  addOpenTrigger(eventName, element) {
    element.addEventListener(eventName, (e) => {
      performance.mark("click-start");
      e.stopPropagation();
      this.open();
      performance.mark("click-end");
      performance.measure("click-to-open", "click-start", "click-end");
    });
  }
  addCloseTrigger(eventName, element) {
    element.addEventListener(eventName, (e) => {
      e.stopPropagation();
      this.close();
    });
  }
  addToggleTrigger(eventName, element) {
    element.addEventListener(eventName, (e) => {
      e.stopPropagation();
      this.toggle();
    });
  }
  open() {
    performance.mark("open-start");
    if (!this.expanded) {
      performance.mark("expanded-set-start");
      this.expanded = true;
      performance.mark("expanded-set-end");
      performance.measure("expanded-set", "expanded-set-start", "expanded-set-end");
      if (this.overflowHiddenMob && window.innerWidth < 640 || this.overflowHiddenDsk && window.innerWidth >= 640) {
        document.documentElement.style.setProperty("overflow", "hidden");
      }
      if (this.dataset.type === "cart-drawer") {
        pushCartDataLayer();
      }
    }
    performance.mark("open-end");
    performance.measure("total-open", "open-start", "open-end");
    return this.expanded;
  }
  close() {
    if (this.expanded) {
      this.expanded = false;
      if (this.overflowHiddenMob && window.innerWidth < 640 || this.overflowHiddenDsk && window.innerWidth >= 640) {
        document.documentElement.style.removeProperty("overflow");
      }
    }
    return this.expanded;
  }
  toggle() {
    if (this.expanded) {
      return this.close();
    } else {
      return this.open();
    }
  }
  get expanded() {
    return this.getAttribute("aria-expanded") === "true";
  }
  set expanded(value) {
    performance.mark("expanded-setter-start");
    const boolValue = Boolean(value);
    this.setAttribute("aria-expanded", boolValue);
    performance.mark("expanded-setter-end");
    performance.measure("expanded-setter", "expanded-setter-start", "expanded-setter-end");
  }
}
class DynamicModal extends GModal {
  constructor() {
    super();
    this.contents = {};
    this.currentContentKey = null;
  }
  addOpenTrigger(eventName, element, contentKey) {
    const content = document.querySelector(`[data-modal-content="${contentKey}"]`);
    if (content) {
      this.contents[contentKey] = content;
    } else {
      console.warn("Modal content not found");
      return;
    }
    element.addEventListener(eventName, (e) => {
      e.stopPropagation();
      if (this.currentContentKey !== contentKey) {
        this.currentContentKey = contentKey;
        this.content.innerHTML = this.contents[contentKey].innerHTML;
      }
      this.open();
    });
  }
}
class FetchModal extends GModal {
  constructor() {
    super();
    this.currentContentKey = null;
  }
  addOpenTrigger(eventName, element, contentKey) {
    element.addEventListener(eventName, async (e) => {
      e.stopPropagation();
      this.currentContentKey = contentKey;
      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      await this._fetchContent();
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      this.open();
    });
  }
  async _fetchContent() {
    if (!this.currentContentKey) {
      console.warn("Empty content key");
      return;
    }
    try {
      const response = await fetch("/search?sections=" + this.currentContentKey);
      const json = await response.json();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = json[Object.keys(json)[0]];
      const newContent = tempDiv.querySelector("#fetch-content");
      if (!newContent) {
        console.warn("No content");
        return;
      }
      this.content.innerHTML = newContent.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }
}
class ModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.action = this.dataset.action || "open";
    this.eventName = this.dataset.eventName || "click";
    this.contentKey = this.dataset.contentKey || null;
    const modalSelector = this.dataset.modalSelector || (this.contentKey ? "dynamic-modal" : "g-modal");
    this.modal = document.querySelector(modalSelector);
  }
  connectedCallback() {
    if (this.modal) {
      switch (this.action) {
        case "open":
          this.modal.addOpenTrigger(this.eventName, this, this.contentKey);
          break;
        case "close":
          this.modal.addCloseTrigger(this.eventName, this);
          break;
        case "toggle":
          this.modal.addToggleTrigger(this.eventName, this);
          break;
      }
    } else {
      console.warn("Modal not found");
    }
  }
}
window.customElements.define("g-modal", GModal);
window.customElements.define("dynamic-modal", DynamicModal);
window.customElements.define("fetch-modal", FetchModal);
window.customElements.define("modal-trigger", ModalTrigger);
const _GDropdown = class _GDropdown extends HTMLElement {
  static handleClickOutside(e) {
    _GDropdown.instances.forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.close();
      }
    });
  }
  constructor() {
    super();
    this._selected = this.querySelector(".js-selected");
    this._input = this.querySelector("input");
    this._items = this.querySelectorAll("[data-value]");
  }
  connectedCallback() {
    if (_GDropdown.instances.size === 0) {
      window.addEventListener("click", _GDropdown.handleClickOutside);
    }
    _GDropdown.instances.add(this);
    this.addEventListener("click", (e) => {
      if (!this.expanded) {
        this.open();
      } else {
        this.close();
      }
    });
    this._items.forEach((item) => item.addEventListener("click", (e) => {
      this.value = item.dataset.value;
    }));
  }
  disconnectedCallaback() {
    _GDropdown.instances.delete(this);
    if (_GDropdown.instances.size === 0) {
      window.removeEventListener("click", _GDropdown.handleClickOutside);
    }
  }
  set value(value) {
    if (value === this._input.value) {
      return;
    }
    const item = this.querySelector(`[data-value="${value}"]`);
    if (item) {
      this.querySelector(`[data-value="${this._input.value}"]`).setAttribute("aria-selected", "false");
      item.setAttribute("aria-selected", "true");
      this._selected.innerHTML = item.innerHTML;
      this._input.value = value;
      this.dispatchEvent(new Event("change"));
    } else {
      console.error(`There is no item with value: ${value}`);
    }
  }
  get value() {
    return this._input.value;
  }
  close() {
    this.expanded = false;
  }
  open() {
    this.expanded = true;
  }
  get expanded() {
    return this.getAttribute("aria-expanded") === "true";
  }
  set expanded(value) {
    this.setAttribute("aria-expanded", Boolean(value));
  }
};
__publicField(_GDropdown, "instances", /* @__PURE__ */ new Set());
let GDropdown = _GDropdown;
window.customElements.define("g-dropdown", GDropdown);
export {
  GModal as G,
  GDropdown as a
};
//# sourceMappingURL=g-dropdown.fae1b620.chunk.js.map
